import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Switch } from '@chakra-ui/react'
import { Layout, Container, PageTitle } from 'src/components/Layout'
import List from 'src/components/List/List'
import Loader from 'src/components/Loader/Loader'
import { isChatCurrentlyEnabled, isFeatureUsed } from 'src/utils/features'
import { hasFeatureFlag, isEmpty } from 'src/utils/helpers'
import PushService from 'src/utils/push-service'
import intlMessagesApp from 'src/modules/App/translations'
import intlMessages from '../translations'
import styles from './Notifications.module.less'
import withToast from 'src/components/Toast'
class Notifications extends Component {
  static contextTypes = {
    router: PropTypes.object,
  }

  state = {
    hasChat: false,
    hasEdoc: false,
  }

  componentDidMount() {
    // Load current settings
    const { getUserPushSettings } = this.props

    if (typeof getUserPushSettings === 'function') {
      getUserPushSettings()
    }
  }

  componentDidUpdate(prevProps) {
    const {
      intl,
      submitGetUserPushSettingsResponse,
      getUserPushSettingsPayload,
      submitSaveUserPushSettingsResponse,
      toast,
    } = this.props

    // If there is API response and it changed (it's empty object while submitting)
    if (
      !isEmpty(submitGetUserPushSettingsResponse) &&
      submitGetUserPushSettingsResponse !== prevProps.submitGetUserPushSettingsResponse
    ) {
      if (!submitGetUserPushSettingsResponse.success) {
        toast({
          title: intl.formatMessage(intlMessagesApp.appErrorTitle),
          description:
            submitGetUserPushSettingsResponse.message ||
            intl.formatMessage(intlMessagesApp.appErrorDescription),
          status: 'error',
        })
        return false
      }

      const hasChat =
        getUserPushSettingsPayload && getUserPushSettingsPayload.hasOwnProperty('hasChat')
          ? getUserPushSettingsPayload.hasChat
          : this.state.hasChat

      const hasEdoc =
        getUserPushSettingsPayload && getUserPushSettingsPayload.hasOwnProperty('hasEdoc')
          ? getUserPushSettingsPayload.hasEdoc
          : this.state.hasEdoc

      this.setState({
        hasChat: hasChat,
        hasEdoc: hasEdoc,
      })
    }

    // If there is API response and it changed (it's empty object while submitting)
    if (
      !isEmpty(submitSaveUserPushSettingsResponse) &&
      submitSaveUserPushSettingsResponse !== prevProps.submitSaveUserPushSettingsResponse
    ) {
      if (!submitSaveUserPushSettingsResponse.success) {
        toast({
          title: intl.formatMessage(intlMessagesApp.appErrorTitle),
          description:
            submitSaveUserPushSettingsResponse.message ||
            intl.formatMessage(intlMessagesApp.appErrorDescription),
          status: 'error',
        })
        return false
      }
    }
  }

  listItemClick = item => {
    if (!(item && item.hasOwnProperty('notificationFieldName'))) {
      return false
    }

    const { saveUserPushSettings, featureFlags, isWidgetState, user } = this.props

    // Just the opposite of current state
    const newSelectState = !this.state[item.notificationFieldName]

    // Turn on
    if (newSelectState) {
      let requestPermissions = false

      // Turn on - Chat
      if (item.notificationFieldName === 'hasChat') {
        requestPermissions = PushService.isEnabled('chat', user, featureFlags, isWidgetState)
      }

      // Turn on - Documents
      if (item.notificationFieldName === 'hasEdoc') {
        requestPermissions = PushService.isEnabled('documents', user, featureFlags, isWidgetState)
      }

      // Request permission to receive push notifications
      if (requestPermissions) {
        PushService.requestPermissionToAllowNotifications(isWidgetState)
      }
    }

    this.setState(
      {
        // Toggle selected option
        [item.notificationFieldName]: newSelectState,
      },
      () => {
        const { hasChat, hasEdoc } = this.state

        // Save both settings
        saveUserPushSettings({
          hasChat,
          hasEdoc,
        })
      },
    )
  }

  getListItems = () => {
    const { intl, featureFlags, features, chat } = this.props

    const { hasChat, hasEdoc } = this.state

    let items = []

    // If push feature flag is used and feature is enabled in settings
    const hasPushChat = hasFeatureFlag(featureFlags, 'push.chat') && isChatCurrentlyEnabled(chat)
    const hasPushDocs =
      hasFeatureFlag(featureFlags, 'push.documents') && isFeatureUsed('documents', features)

    // If chat push is enabled
    if (hasPushChat) {
      items.push({
        leftIcon: null,
        notificationFieldName: 'hasChat',
        name: intl.formatMessage(intlMessages.userNotificationsChatNotificationsTitle),
        description: intl.formatMessage(intlMessages.userNotificationsChatNotificationsSubtitle),
        customRightIcon: () => <Switch isChecked={hasChat} />,
        customRightIconShift: true,
      })
    }

    // If document push is enabled
    if (hasPushDocs) {
      items.push({
        leftIcon: null,
        notificationFieldName: 'hasEdoc',
        name: intl.formatMessage(intlMessages.userNotificationsDocumentsNotificationsTitle),
        description: intl.formatMessage(
          intlMessages.userNotificationsDocumentsNotificationsSubtitle,
        ),
        customRightIcon: () => <Switch isChecked={hasEdoc} />,
        customRightIconShift: true,
      })
    }

    return items
  }

  render() {
    const { intl, isGetUserPushSettingsInProgress } = this.props

    // TODO: PAT-1914 Show loading as overlay (on top of content) after redesign,
    //  with isSaveUserPushSettingsInProgress

    const listItems = this.getListItems()

    return (
      <Layout>
        <PageTitle
          title={intl.formatMessage(intlMessages.userNotificationsHeadline)}
          subtitle={<FormattedMessage id='app.profileTab' defaultMessage='Profile' />}
        />
        <Container
          className={cx({
            'global-centered-desktop-content': true,
            [styles.container]: true,
          })}
        >
          {isGetUserPushSettingsInProgress ? (
            <Loader styleVariation='staticWithHeight' />
          ) : (
            <div>
              {isEmpty(listItems) ? (
                <h3 className={styles.noResults}>
                  {intl.formatMessage(intlMessages.userNotificationsAllDisabled)}
                </h3>
              ) : (
                <List
                  items={listItems}
                  onClick={this.listItemClick}
                  noResultsMessage={intl.formatMessage(intlMessagesApp.appGlobalNoResults)}
                  classNameListItem={styles.listItem}
                />
              )}
            </div>
          )}
        </Container>
      </Layout>
    )
  }
}

export default injectIntl(withToast(Notifications))
